import React, { useState, useEffect } from 'react';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import { getReviews } from '../utils/api';
import './Reviews.css';

const Reviews = () => {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchReviews();
    }, []);

    const fetchReviews = async () => {
        try {
            const data = await getReviews();
            setReviews(data.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching reviews:', error);
            setLoading(false);
        }
    };

    const renderStars = (rating) => {
        return [...Array(5)].map((_, index) => (
            <FaStar
                key={index}
                className={index < rating ? 'star-filled' : 'star-empty'}
            />
        ));
    };

    if (loading) {
        return (
            <section className="reviews section" id="reviews">
                <div className="container">
                    <div className="spinner"></div>
                </div>
            </section>
        );
    }

    return (
        <section className="reviews section" id="reviews">
            <div className="container">
                <div className="section-header text-center">
                    <span className="section-tag">Testimonials</span>
                    <h2 className="section-title">
                        What Our <span className="text-gradient">Clients Say</span>
                    </h2>
                    <p className="section-description">
                        Don't just take our word for it - hear from our satisfied clients
                    </p>
                </div>

                <div className="reviews-header-card">
                    <div className="google-rating">
                        <div className="rating-badge">
                            <img
                                src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png"
                                alt="Google"
                                className="google-logo"
                            />
                            <div className="rating-info">
                                <div className="stars">{renderStars(5)}</div>
                                <p className="rating-text">
                                    <strong>4.9</strong> based on <strong>258+</strong> reviews
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="reviews-grid">
                    {reviews.map((review, index) => (
                        <div className="review-card card" key={index}>
                            <div className="quote-icon">
                                <FaQuoteLeft />
                            </div>
                            <div className="review-stars">{renderStars(review.rating)}</div>
                            <p className="review-comment">{review.comment}</p>
                            <div className="review-author">
                                <div className="author-avatar">
                                    {review.name.charAt(0).toUpperCase()}
                                </div>
                                <div className="author-info">
                                    <h4>{review.name}</h4>
                                    <p>Verified Client</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="reviews-cta">
                    <p>Join thousands of satisfied clients who trust us for their healthcare needs</p>
                    <a href="tel:9082033873" className="btn btn-primary">
                        Book Your Service Now
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Reviews;